import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { FaThLarge, FaList } from "react-icons/fa";
import { MiniStoreThemeContext } from "../../MiniStoreContexts/MiniStoreThemeContext";
import Modal from "../../Components/Kanban/Modal/Modal";
import ExploreBtns from "../../Components/MiniStore/ExploreBtns/ExploreBtns";
import { Outlet, useLocation } from "react-router-dom";
import { EXPLORE_BTNS_MINI_STORE } from "../../utilities/constants";
import { CartContext } from "../../contexts/MiniStore/CartContext";
import "react-responsive-pagination/themes/classic.css";
import { fetchProductVariants } from "../../DataApi/miniStore/fetchProductVariants";
import ProductCardModal from "./Card/ProductCardModal";

const MsPromotions = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  const { cart, addToCart, updateQuantity, setVariants, setSelectedVariant } =
    useContext(CartContext);
  const [isGrid, setIsGrid] = useState(true);

  const [isProductWizardOpen, setIsProductWizardOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const location = useLocation();

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const lastSegment =
    pathSegments.length > 2 ? pathSegments[pathSegments.length - 1] : null;
  const pageTitle =
    EXPLORE_BTNS_MINI_STORE.find((route) => route.path === lastSegment)
      ?.title || "Promotions";

  const handleOpenProductModal = async (product) => {
    // console.log("product clicked", product);
    const getProductVariants = await fetchProductVariants({
      product_tmpl_id: product.id,
    });
    // console.log("product variants", getProductVariants);
    const formattedProductVariants = getProductVariants?.result.map(
      (product) => ({
        id: product?.id,
        title: product?.name || "",
        rating: product?.rating_avg || 0,
        quantity: getCartQuantity(product.id),
        currency: product?.currency_id,
        price: product?.lst_price.toFixed(2) || 0,
        newPrice: product?.pricelist_price.toFixed(2) || 0,
        has_discounted_price: product?.has_discounted_price || false,
        discount: 0,
        description: product?.description_sale || "",
        image_1920: product?.img_url,
        hasVariant: product?.attribute_line_ids?.length > 0 ? true : false,
        availableQty: product?.qty_available || 0,
        variant_ids: product?.product_variant_ids || [],
        attr_val_data: product?.attr_val_data || [],
      })
    );
    setVariants(formattedProductVariants);
    setSelectedVariant(formattedProductVariants[0]);
    setSelectedProduct(product);
    setIsProductWizardOpen(true);
  };
  const handleProductWizardClose = () => {
    setIsProductWizardOpen(false);
  };
  const getCartQuantity = (id) => {
    const cartItem = cart.find((item) => item.id === id);
    return cartItem?.quantity || 0;
  };

  return (
    <Container>
      <PageTitle>{pageTitle}</PageTitle>
      <ToggleButtons>
        <IconButton
          theme={theme}
          isActive={isGrid}
          onClick={() => setIsGrid(true)}
        >
          <FaThLarge />
        </IconButton>
        <IconButton
          theme={theme}
          isActive={!isGrid}
          onClick={() => setIsGrid(false)}
        >
          <FaList />
        </IconButton>
      </ToggleButtons>
      {isProductWizardOpen && selectedProduct && (
        <Modal
          isOpen={isProductWizardOpen}
          onClose={handleProductWizardClose}
          closeButton={true}
          miniStore={true}
        >
          {(() => {
            const cartItem = cart.find(
              (item) => item.id === selectedProduct.variant_ids?.[0]
            );
            return (
              <ProductCardModal
                key={selectedProduct.id}
                id={selectedProduct.id}
                title={selectedProduct.title}
                rating={selectedProduct.rating}
                quantity={cartItem?.quantity || 0}
                currency={selectedProduct.currency}
                description={selectedProduct.description}
                price={selectedProduct.price}
                newPrice={selectedProduct.newPrice}
                has_discounted_price={selectedProduct.has_discounted_price}
                img={selectedProduct.image_1920}
                onQuantityChange={updateQuantity}
                onAddToCart={addToCart}
              />
            );
          })()}
        </Modal>
      )}
      <Outlet
        context={{
          isGrid,
          handleOpenProductModal,
        }}
      />
      <ExploreBtns />
    </Container>
  );
};

export default MsPromotions;

// Styled Components

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;
const PageTitle = styled.div`
  font-family: Outfit, sans-serif;
  font-size: 38px;
  font-weight: 500;
  line-height: 29px;
  text-align: center;
  @media only screen and (max-width: 768px) {
    font-size: 28px;
  }
`;
const ToggleButtons = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: center;
`;

const IconButton = styled.button`
  background: ${({ isActive, theme }) =>
    isActive ? theme.primaryColor.primary : "#ccc"};
  color: ${({ theme }) => theme.textColor.primary};
  border: none;
  padding: 10px 15px;
  border-radius: 0.15rem;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    opacity: 0.85;
  }
`;

const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ isGrid }) =>
    isGrid ? "repeat(auto-fit, minmax(250px, 1fr))" : "1fr"};
  gap: 16px;
  width: 100%;
  max-width: 900px;
  place-items: start center;
  @media (max-width: 768px) {
    grid-template-columns: ${({ isGrid }) =>
      isGrid ? "repeat(2, minmax(0, 1fr))" : "1fr"};
  }
`;
